import { css } from "styled-components";

const buttonStyles = css`
color: #33ADFF;
background: #FFFFFF;
border: 0.572641px solid #33ADFF;
`;

export default buttonStyles;
